import { render, staticRenderFns } from "./DocumentUpload.vue?vue&type=template&id=13bd1332&scoped=true&"
import script from "./DocumentUpload.vue?vue&type=script&lang=ts&"
export * from "./DocumentUpload.vue?vue&type=script&lang=ts&"
import style0 from "./DocumentUpload.vue?vue&type=style&index=0&id=13bd1332&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13bd1332",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VFileInput } from 'vuetify/lib/components/VFileInput';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VFileInput,VRow})
